import React from "react";
import {
    ButtonDownloadTemplate,
    FilePanelDescription,
    FilePanelTitle,
} from '../../components';

const FileTemplateDownloader = ({title, description, apiUrl, buttonId = ''}) => {
  return (
      <div className="upload-file__panel xl:py-[24px] xl:px-[32px] md:py-[20px] md:px-[24px] h-full w-full flex flex-col items-center xl:space-y-6 lg:space-y-5 space-y-4">
         <FilePanelTitle title={title}/>
         <FilePanelDescription description={description} />
          <div className="flex items-center 2xl:px-[40px] xl:px-[32px] lg:px-[20px] md:px-[16px]">
              <ButtonDownloadTemplate text="テンプレートをダウンロード" apiUrl={apiUrl} />
          </div>
      </div>
  );
};

export default FileTemplateDownloader;